import React, { useState, useRef } from "react";
import emailjs from "@emailjs/browser";
import { Link } from 'react-router-dom';
import { FaFacebookF, FaInstagram, FaEnvelope,FaBars,FaTimes} from "react-icons/fa";
import Navbar from "./Navbar";


const Appointment = () => {
  const formRef = useRef();
      const [menuOpen, setMenuOpen] = useState(false);
  const [formData, setFormData] = useState({
    name: "",
    email: "",

    selectedDate: "",
    selectedTime: "",
  });


  const timeSlots = [
    "7:00 AM", "7:30 AM", "8:00 AM", "8:30 AM", "9:00 AM", "9:30 AM",
    "10:00 AM", "10:30 AM", "11:00 AM", "11:30 AM", "12:00 PM",
    "12:30 PM", "1:00 PM", "1:30 PM", "2:00 PM", "2:30 PM", "3:00 PM",
    "3:30 PM", "4:00 PM", "4:30 PM", "5:00 PM", "5:30 PM", "6:00 PM",
    "6:30 PM", "7:00 PM", "7:30 PM", "8:00 PM", "8:30 PM", "9:00 PM",
    "9:30 PM", "10:00 PM"
  ];

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const sendEmail = (e) => {
    e.preventDefault();

    if (!formData.name || !formData.email ||  !formData.selectedDate || !formData.selectedTime) {
      alert("Please fill all fields before submitting!");
      return;
    }

    emailjs.sendForm("service_yw7lpbq", "template_empmsu9", formRef.current, "IsywhZrX5_2nwhrWU")
      .then(() => {
        alert(`Appointment booked on ${formData.selectedDay}, ${formData.selectedDate} at ${formData.selectedTime}`);
        setFormData({ name: "", email: "", selectedDay: "", selectedDate: "", selectedTime: "" });
      })
      .catch((error) => {
        console.error("EmailJS Error:", error);
        alert("Failed to send email. Please try again.");
      });
  };

  return (
    <>
     <Navbar/>
    <div className="w-full flex flex-col items-center bg-white py-12 px-4 md:px-8 lg:px-12 font-serif">
      
      {/* Form Container */}
      <div className="w-full max-w-2xl">
        <h2 className="text-3xl font-semibold text-blue-700 mb-4 text-center">Book an Appointment</h2>
        <div className="w-24 h-1 bg-blue-700 mx-auto mb-6"></div>

        <form ref={formRef} onSubmit={sendEmail} className="space-y-6">
          {/* Name Input */}
          <div>
            <label className="block text-gray-700 text-lg font-medium">Name</label>
            <input
              type="text"
              name="name"
              value={formData.name}
              onChange={handleChange}
              required
              className="w-full p-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-700 text-lg"
            />
          </div>

          {/* Email Input */}
          <div>
            <label className="block text-gray-700 text-lg font-medium">Email</label>
            <input
              type="email"
              name="email"
              value={formData.email}
              onChange={handleChange}
              required
              className="w-full p-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-700 text-lg"
            />
          </div>

       

          {/* Date Selection */}
          <div>
            <label className="block text-gray-700 text-lg font-medium">Select a Date</label>
            <input
              type="date"
              name="selectedDate"
              value={formData.selectedDate}
              onChange={handleChange}
              required
              className="w-full p-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-700 text-lg"
            />
          </div>

          {/* Time Slot Selection */}
          <div>
            <label className="block text-gray-700 text-lg font-medium">Select a Time Slot</label>
            <select
              name="selectedTime"
              value={formData.selectedTime}
              onChange={handleChange}
              required
              className="w-full p-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-700 text-lg"
            >
              <option value="">Select a Time</option>
              {timeSlots.map((time, index) => (
                <option key={index} value={time}>{time}</option>
              ))}
            </select>
          </div>

          {/* Submit Button */}
          <button
            type="submit"
            className="w-full bg-blue-700 text-white py-3 rounded-full text-lg font-semibold hover:bg-blue-800 transition duration-300"
          >
            Book Appointment
          </button>
        </form>
      </div>
    </div>
      <footer className="w-full mt-12 p-6 bg-gray-900 text-white text-center transition duration-300 hover:bg-gray-800">
                <p className="text-sm">© 2025 The Quraniverse.ai. All Rights Reserved.</p>
                <div className="flex justify-center space-x-6 mt-4">
                  <a href="https://www.facebook.com/profile.php?id=61573829216416" target="_blank" rel="noopener noreferrer" className="text-white text-2xl hover:text-gray-400"><FaFacebookF /></a>
                  <a href="https://www.instagram.com/quraniverse_ai?igsh=MWo3c2trbXVodnhpbA==" target="_blank" rel="noopener noreferrer" className="text-white text-2xl hover:text-gray-400"><FaInstagram /></a>
                  <a href="mailto:info@quraniverse.ai" className="text-white text-2xl hover:text-gray-400"><FaEnvelope /></a>
                </div>
              </footer>
    </>
  );
};

export default Appointment;
